import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type TaskApiError = {
  error?: string;
  status: FetchBaseQueryError['status'];
};

const messageFrom = (value: unknown): string | undefined => {
  if (!value || typeof value !== 'object' || !('error' in value)) {
    return undefined;
  }
  const error = (value as { error?: unknown }).error;
  if (typeof error !== 'string') {
    return undefined;
  }
  const message = error.trim();
  return message || undefined;
};

export const taskApiError = (response: FetchBaseQueryError): TaskApiError => ({
  error: messageFrom('data' in response ? response.data : undefined),
  status: response.status,
});

export const taskWriteErrorMessage = (payload: unknown): string | undefined => (
  messageFrom(payload)
);

export const mutationFailed = (result: unknown): boolean => (
  result != null
  && typeof result === 'object'
  && 'error' in result
  && Boolean(result.error)
);
